import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as arrearsActions from '../actions/arrears.actions';
import { ArrearsHttpService } from '../services/arrears-http.service';
import { ArrearsCollection } from '../models/arrears-collection';

import { AdminArrearsDataModel } from '../models/admin-arrears-data.model';
import { switchMap, map, catchError } from 'rxjs';

@Injectable()
export class ArrearsEffects {

  constructor(private actions$: Actions, private arrearsHttpService: ArrearsHttpService) {
  }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<arrearsActions.Load>(arrearsActions.LOAD),
    switchMap(action => {
      return this.arrearsHttpService.getArrears(action.context).pipe(
        map((arrears: ArrearsCollection) => new arrearsActions.LoadComplete(arrears, action.widgetId)),
        catchError(err => of(new arrearsActions.LoadError(err, action.widgetId)))
      );
    })));


  
  loadAdminData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<arrearsActions.LoadAdminData>(arrearsActions.LOAD_ADMIN_DATA),
    switchMap(action => {
      return this.arrearsHttpService.getAdminArrearsData().pipe(
        map((data: AdminArrearsDataModel) => new arrearsActions.LoadAdminDataComplete(data)),
        catchError(err => of(new arrearsActions.LoadAdminDataError(err)))
      );
    })));
}
